import React from 'react';
import { Route } from 'react-router-dom';
import Register from './Register';
import SilvasoftSettings from './silvasoft/SilvasoftSettings';
import Facturatie from './silvasoft/Facturatie';
import FraudMeasures from './misc/FraudMeasures';

export default [
    <Route exact path="/register" component={Register} />,
    <Route exact path="/silvasoft" component={SilvasoftSettings} />,
    <Route exact path="/facturatie" component={Facturatie} />,
    <Route exact path="/klik-fraude-uitleg" component={FraudMeasures} />
];


// WEBPACK FOOTER //
// ./src/routes.js